<form *ngIf="reportForm" [formGroup]="reportForm">
    <div class="row row d-flex justify-content-center my-3">

        <div class="col-8">
            <div class="form-group row p-0 d-flex justify-content-center">
                <label class="col-3 col-form-label">
                    จำนวนอันดับ
                    <br><small class="text-danger">* ลักษณะทางจิตวิทยาต้องมากกว่าหรือเท่ากับจำนวนอันดับ</small>
                </label>
                <div class="col-6">
                    <select class="custom-select form-control float-left" style="width: 100%;" formControlName="NUMBER_OF_RANK">
                        <option value="" selected hidden disabled>เลือกลำดับ</option>
                        <option value="1">Top 1</option>
                        <option value="2">Top 2</option>
                        <option value="3">Top 3</option>
                        <option value="4">Top 4</option>
                        <option value="5">Top 5</option>
                        <option value="6">Top 6</option>
                        <option value="7">Top 7</option>
                        <option value="8">Top 8</option>
                        <option value="9">Top 9</option>
                        <option value="10">Top 10</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="form-group">
                <label for="spiderDescription">คำอธิบายรายงานแบบทดสอบ</label>
                <textarea formControlName="TEMPLATE_DES" class="form-control" id="spiderDescription" rows="3"
                    maxlength="1500"></textarea>
                <p class="text-right">{{ reportForm.value.TEMPLATE_DES.length | number }}/1,500</p>
            </div>
        </div>

        <h3 class="text-center my-4">ลักษณะทางจิตวิทยา</h3>
        <div class="col-12">
            <div *ngFor="let r of reportForm.get('PSY_BLOCKS')['controls']; let i = index" formArrayName="PSY_BLOCKS">
                <div [formGroupName]="i" class="box mt-4">
                    <button *ngIf="i !== 0" mat-mini-fab class="img close-btn" (click)="removeGroup(i, true)"
                        [style.backgroundImage]="'url(\'../../../../assets/close.png\')'"></button>
                    <div class="form-group row" style="margin-top: 60px;">
                        <label for="psycoGroup" class="col-sm-3 col-form-label">ลักษณะทางจิตวิทยา</label>
                        <div class="col-sm-9">
                            <input formControlName="PSY_NAME" type="text" class="form-control" id="psycoGroup">
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="color" class="col-3 col-form-label">สี</label>
                        <!-- <div class="col-1"></div> -->
                        <div class="col-sm-9">
                            <input formControlName="COLOR_CODE" type="color" id="color" class="form-control"
                                style="width: 20%;">
                            <small *ngIf="!r.value.COLOR_CODE" class="col-form-label" class="text-danger">
                                ยังไม่ได้ใส่สี ✖
                            </small>
                            <small *ngIf="r.value.COLOR_CODE" class="col-form-label" class="text-success">
                                ใส่สีเรียบร้อย ✔
                            </small>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="spiderDescription" class="col-form-label">คำอธิบายลักษณะทางจิตวิทยา</label>
                        <textarea formControlName="DETAIL_PSY" class="form-control" id="spiderDescription" rows="3"
                            maxlength="1500"></textarea>
                        <p class="text-right">{{ reportForm.value.PSY_BLOCKS[i].DETAIL_PSY.length | number }}/1,500</p>
                    </div>

                    <div class="row justify-content-center">
                        <lifedi-btn *ngIf="!this.reportForm.value.PSY_BLOCKS[i].CAL" lable="การคำนวณ"
                            (click)="openCalculateModal(reportForm.get('PSY_BLOCKS'), i, false)"
                            customStyle="background-color: #060E9F; color: #FFF; margin: 0px 5px 10px 0px; padding: 0 30px;">
                        </lifedi-btn>
                        <lifedi-btn *ngIf="this.reportForm.value.PSY_BLOCKS[i].CAL" lable="แก้ไขการคำนวณ"
                            (click)="openCalculateModal(reportForm.get('PSY_BLOCKS'), i, true)"
                            customStyle="background-color: #060E9F; color: #FFF; margin: 0px 5px 10px 0px; padding: 0 30px;">
                        </lifedi-btn>
                    </div>

                    <div class="row justify-content-center">
                        <small *ngIf="!this.reportForm.value.PSY_BLOCKS[i].CAL" class="col-form-label"
                            class="text-danger">
                            ยังไม่ได้ใส่วิธีการคำนวณ ✖
                        </small>
                        <small *ngIf="this.reportForm.value.PSY_BLOCKS[i].CAL" class="col-form-label"
                            class="text-success">
                            ใส่วิธีการคำนวณแล้ว ✔
                        </small>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <lifedi-btn lable="เพิ่มลักษะทางจิตวิทยา" (click)="addGroup()"
                    customStyle="background-color: #00AF80; color: #FFF; margin: 20px 5px 20px 0px; padding: 0 30px;">
                </lifedi-btn>
            </div>
        </div>
    </div>
</form>